// components/recordViewOnce.js
import dayjs from 'dayjs';
import { db } from '@root/firebase';
import {
  collection,
  doc as fsDoc,
  runTransaction,
  serverTimestamp,
  increment,
} from 'firebase/firestore';

/**
 * Record a unique view (per user per day) on the given docPath.
 * Safe to call multiple times (click + detail mount) — transaction dedupes it.
 */
export async function recordViewOnce({ docPath, userId }) {
  if (!db || !docPath || !userId) return; // no-op if missing context

  const today = dayjs().format('YYYYMMDD');
  const parentRef = fsDoc(db, docPath);
  const viewsCol = collection(db, `${docPath}/views`);
  const viewDocRef = fsDoc(viewsCol, `${userId}_${today}`);

  await runTransaction(db, async (tx) => {
    const v = await tx.get(viewDocRef);
    if (!v.exists()) {
      tx.set(viewDocRef, {
        uid: userId,
        dateKey: today,
        createdAt: serverTimestamp(),
      });
      tx.update(parentRef, { totalViews: increment(1) });
    }
  });
}
